export default {"src":"/_next/static/media/0x18c11fd286c5ec11c3b683caa813b77f5163a122.dabf124f.svg","height":2500,"width":2500,"blurWidth":0,"blurHeight":0};